import { Grid } from '@mui/material';
import React from 'react';
import { withStyles } from 'tss-react/mui';
import { LOGIN_BANNER_IMG } from '../../../constants/images';

const styles = theme => ({
  imageLogo: {
    maxWidth: '550px',
    width: '100%',
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(3),
      '@media (max-height: 750px)': {
        marginTop: theme.spacing(1.5)
      }
    }
  },
  mobileimagewrapper: {
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  paper: {
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(2),
      '@media (max-height: 750px)': {
        margin: theme.spacing(1)
      }
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
});

const LoginBannerImage = props => {
  const { classes, ready, src, onLoad } = props;

  return (
    <Grid size={{ xs: 12, sm: 12, md: false }} className={classes.mobileimagewrapper}>
      <div className={classes.paper}>
        <img
          className={`${classes.imageLogo} logo-fade-in-anim`}
          src={src || LOGIN_BANNER_IMG}
          alt=""
          style={!ready ? { visibility: 'hidden' } : undefined}
          onLoad={onLoad}
        />
      </div>
    </Grid>
  );
};

export default withStyles(LoginBannerImage, styles);
